export default class Auth {
  static tokenKey = 'jwt_token';

  static getToken(): string | null {
    return localStorage.getItem(Auth.tokenKey);
  }

  static setToken(token: string): void {
    localStorage.setItem(Auth.tokenKey, token);
  }

  static setGoogleId(googleId: string): void {
    localStorage.setItem('google_id', googleId);
  }

  static clearToken(): void {
    localStorage.removeItem(Auth.tokenKey);
  }

  static isLoggedIn(): boolean {
    return !!this.getToken();
  }

  static logout(): void {
    this.clearToken();
    location.reload();
  }

  static async validateToken(): Promise<boolean> {
    const token = this.getToken();
    if (!token) return false;

    try {
      const res = await fetch(`/api/auth/me`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      return res.ok;
    } catch (err) {
      console.error("Token validation error", err);
      return false;
    }
  }

  static getUserInfo(): { email: string, name: string, picture: string, sub: string } | null {
    const token = this.getToken();
    if (!token) return null;

    try {
      const payload = JSON.parse(atob(token.split('.')[1]));
      return {
        email: payload.email,
        name: payload.name || '',
        picture: payload.picture || '',
        sub: payload.sub || '',
      };
    } catch (e) {
      return null;
    }
  }

  static loginWithGoogle() {
    // Через /api/ — проксується Vite (dev) або nginx (prod)
    window.location.href = `/api/auth/google/login`;
  }
}
